document.addEventListener('DOMContentLoaded', function () {
    const currencysmy = (currency, locale) =>
        new Intl.NumberFormat(locale, { style: 'currency', currency })
            .formatToParts(1)
            .find(x => x.type === "currency")
            .value;
    const currencysymbol = currencysmy(window.ShopifyAnalytics.meta.currency, window.ShopifyAnalytics.meta.locale);

    const productHandle = window.location.pathname.split('/').pop();

    let productReminderPageVisits = parseInt(localStorage.getItem('productReminderPageVisits')) || 0;
    productReminderPageVisits++;
    localStorage.setItem('productReminderPageVisits', productReminderPageVisits);

    function getCartCount(callback) {
        fetch('/cart.js')
            .then(response => response.json())
            .then(data => callback(data.item_count))
            .catch(error => console.error('Error fetching cart data:', error));
    }

    if (window.location.pathname.includes('/products/')) {
        let recentlyViewed = JSON.parse(localStorage.getItem('productReminder')) || [];

        if (!recentlyViewed.includes(productHandle)) {
            recentlyViewed.unshift(productHandle);
            if (recentlyViewed.length > 2) {
                recentlyViewed = recentlyViewed.slice(0, 2);
            }
            localStorage.setItem('productReminder', JSON.stringify(recentlyViewed));
        }
    }

    function getRecentlyViewedProducts() {
        return JSON.parse(localStorage.getItem('productReminder')) || [];
    }

    function fetchProductDetails(handle, callback) {
        fetch(`/products/${handle}.js`)
            .then(response => response.json())
            .then(data => callback(data))
            .catch(error => console.error('Error fetching product details:', error));
    }

    const recentlyViewedProducts = getRecentlyViewedProducts();
    const content = document.getElementById('recently-viewed-content');

    function getPopupClosedTimestamp() {
        return localStorage.getItem('productReminderPopupClosedTimestamp');
    }

    function shouldShowPopup() {
        const popupClosedTimestamp = getPopupClosedTimestamp();
        const currentTime = Date.now();
        const sevenDaysInMs = 7 * 24 * 60 * 60 * 1000;

        return (
            productReminderPageVisits >= 2 &&
            recentlyViewedProducts.length >= 2 &&
            (!popupClosedTimestamp || currentTime - popupClosedTimestamp > sevenDaysInMs)
        );
    }

    function showPopup() {
        document.querySelector('#product-reminder').classList.add('show');
        document.querySelector('body').classList.add('modal-open');
        document.querySelector('.modal-backdrop').classList.add('show');
    }

    if (recentlyViewedProducts.length >= 2) {
        let productsLoaded = 0;

        recentlyViewedProducts.forEach(handle => {
            fetchProductDetails(handle, function (product) {
                const productHtml = `
                    <div class="product">
                        <a href="/products/${product.handle}" class="product-reminder-link" id="product-reminder-link">
                            <img src="${product.images[0]}" alt="${product.title}" loading="lazy"/>
                            <div class="product-content">
                                <p>${product.title}</p>
                                <p>${currencysymbol}${product.price / 100}</p>
                                <div id="view-item" class="button button--primary">View Item</div>
                            </div>
                        </a>
                    </div>
                `;
                content.insertAdjacentHTML('beforeend', productHtml);
                productsLoaded++;
            });
        });
    }

    document.addEventListener('mouseout', function (event) {
        if (event.clientY < 0 && shouldShowPopup()) {
            getCartCount(function(cartCount) {
                if (cartCount < 1) {
                    showPopup();
                }
            });
        }
    });

    // Debugging statement to confirm that close button exists
    console.log('Popup close button:', document.querySelector('.product-reminder-close'));

    document.querySelector('.product-reminder-close').addEventListener('click', function () {
        const closeTime = Date.now();
        
        // Debugging statement to ensure the event listener is triggered
        console.log('Popup close clicked. Storing timestamp:', closeTime);

        localStorage.setItem('productReminderPopupClosedTimestamp', closeTime);

        // Confirm the timestamp is correctly stored in localStorage
        console.log('Stored timestamp in localStorage:', localStorage.getItem('productReminderPopupClosedTimestamp'));

        document.querySelector('#product-reminder').classList.remove('show');
        setTimeout(() => {
            document.querySelector('body').classList.remove('modal-open');
            document.querySelector('.modal-backdrop').classList.remove('show');
        }, 200);
    });
});
